var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnblogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "url(#paint0_linear_650_5098)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67643 9.14694L4.68349 11.7354L6.88294 13.0297V14.5452L3.39629 12.5002V8.38999L4.67643 9.14694ZM4.67643 6.55842V8.06682L3.39551 7.30909V5.8007L4.67643 5.04297L5.96363 5.8007L4.67643 6.55842ZM7.80147 5.8007L9.08239 5.04297L10.3696 5.8007L9.08239 6.55842L7.80147 5.8007Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60254 11.1989V9.68347L6.88346 10.4412V11.9496L5.60254 11.1989ZM7.80199 13.5725L9.08291 14.3302L10.3701 13.5725V15.0809L9.08291 15.8386L7.80199 15.0809V13.5725ZM12.2072 5.8007L13.4881 5.04297L14.7753 5.8007V7.30909L13.4881 8.06682V6.55843L12.2072 5.8007ZM13.4881 11.7354L13.4951 9.14694L14.7761 8.38921V12.4995L11.2894 14.5444V13.0289L13.4881 11.7354Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.569 11.199L11.2881 11.9497V10.4413L12.569 9.68359V11.199Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5696 7.09479L12.5766 8.61025L10.3709 9.9045V12.4993L9.08997 13.25L7.80905 12.4993V9.9045L5.60332 8.61025V7.09479L6.88974 6.33706L9.08213 7.63759L11.2879 6.33706L12.575 7.09479H12.5696ZM5.60254 4.50706L9.08291 2.45508L12.5696 4.50706L11.2886 5.26479L9.08291 3.96426L6.88346 5.26479L5.60254 4.50706Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_650_5098",
    x1: 18,
    y1: 18,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD632"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnblogo);
export default __webpack_public_path__ + "static/media/bnblogo.a1a63fd8947138706337a38cb717fbeb.svg";
export { ForwardRef as ReactComponent };